import { Box, Stack } from "@mui/material";
import React, { useState } from "react";
import MyDatePicker from "./DatePicker";
import dayjs from "dayjs";

const MyDateRange = ({
  labelFrom = "Date From",
  labelTo = "Date to",
  min,
  max,
  textSize = 16,
  dateToVal,
  dateFromVal,
  onChangeDateToVal,
  onChangeDateFromVal,
}) => {
  const [dateTo, setDateTo] = useState();
  const [dateFrom, setDateFrom] = useState();

  const handleDateToVal = (newVal) => {
    if (onChangeDateToVal) {
      onChangeDateToVal(newVal);
    } else {
      setDateTo(newVal);
    }
  };
  const handleDateFromVal = (newVal) => {
    if (onChangeDateFromVal) {
      onChangeDateFromVal(newVal);
    } else {
      setDateFrom(newVal);
    }
  };

  return (
    <Stack direction={"column"} gap={1}>
      <MyDatePicker
        textSize={textSize}
        min={min ? dayjs(min) : undefined}
        max={max ? dayjs(max) : undefined}
        value={dateToVal !== undefined ? dateToVal : dateTo}
        onChange={handleDateToVal}
        label={labelFrom}
      />
      <MyDatePicker
        textSize={textSize}
        min={min ? dayjs(min) : undefined}
        max={max ? dayjs(max) : undefined}
        value={dateFromVal !== undefined ? dateFromVal : dateFrom}
        onChange={handleDateFromVal}
        label={labelTo}
      />
    </Stack>
  );
};

export default MyDateRange;
